import { useEffect, useState } from "react";

/**
 * An <img> for an endpoint that requires the bearer token.
 *
 * The chat attachment route re-checks who is asking before it serves a file,
 * so the URL cannot be dropped into src directly - the browser would send no
 * Authorization header and get a 401. Fetch it, render the blob, and revoke
 * the object URL on unmount so a long thread does not leak one per image.
 */
const AuthImage = ({ src, alt = "", className, onClick }) => {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!src) return undefined;

    let objectUrl = null;
    let cancelled = false;

    (async () => {
      setFailed(false);
      try {
        const res = await fetch(src, {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("token")}`,
          },
        });
        if (!res.ok) throw new Error(String(res.status));
        const blob = await res.blob();
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      } catch (_err) {
        if (!cancelled) setFailed(true);
      }
    })();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src]);

  if (failed) {
    return <div className="auth-img-failed">Image unavailable</div>;
  }
  if (!url) {
    return <div className="auth-img-loading" />;
  }
  return <img src={url} alt={alt} className={className} onClick={onClick} />;
};

export default AuthImage;
